module.exports = "/lucky-balls/img/weager/Button_pressed.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/weager/Button_pressed.png
// module id = 1158
// module chunks = 0